export default __webpack_public_path__ + "static/media/undraw_adventure_map_hnin-1.4dd9fb40.svg";